module.exports = __webpack_public_path__ + "static/media/google_login_btn_img.1f450307.png";